import { Component } from '@angular/core';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { SemCallsV1Component } from '../sem-calls-v1/sem-calls-v1.component';
import * as Highcharts from 'highcharts';
import * as moment from 'moment';
import * as _ from 'underscore';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { CallGraph, CallMetrics } from '../../../analytics-core/interfaces/sem-calls.interface';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import {
	HIGHCHARTS_LEGEND_ALIGN,
	HIGHCHARTS_LEGEND_VERTICAL_ALIGN
} from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-sem-calls-v5',
	templateUrl: './sem-calls-v5.component.html',
	styleUrls: ['./sem-calls-v5.component.css']
})
export class SemCallsV5Component extends SemCallsV1Component {
	graphFilterOptions: any = [
		{ id: 1, name: 'All' },
		{ id: 2, name: '1-30 Seconds' },
		{ id: 3, name: '31-60 Seconds' },
		{ id: 4, name: '>60 Seconds' }
	];
	graphFilterOptionsR104: any = [
		{ id: 1, name: 'All' },
		{ id: 2, name: '1-30 Sec' },
		{ id: 3, name: '31-60 Sec' },
		{ id: 4, name: '>60 Sec' }
	];
	selectedValue: number = 1;
	graphFilterDisabled: boolean = false;
	metricsData: any = false;
	public tickPositions: any;
	public defaultCount: number = 14;
	public chartObj: any;
	protected tooltipConfig: any;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService, colorUtilityService, analyticsDataModel);
	}

	//called when call times filter is changed to redraw the calls graph with filtered data
	filterChange(value: any) {
		this.generateGraphData(this.graphData);
		this.chartObj.update({ series: this.graphObj.series });
	}

	// function to make api call and assigned variables
	requestData() {
		this.hasData = false;
		this.showLoad = true;
		this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
			if (response.success) {
				this.mapCallMetricsDataTointerface(response.data);
				if (this.metricsData) {
					this.hasData = false;
					this.selectedValue = 1;
					this.analyticsService.processWidgetRequest(this.tertiarykey).subscribe((response2: any) => {
						this.showLoad = false;
						if (response2.success) {
							this.hasData = true;
							this.graphData = this.mapCallGraphDataToInterface(response2.data);
							if (this.graphData && this.graphData.length > 0) {
								this.generateGraphData(this.graphData);
								setTimeout(() => {
									this.drawGraph();
								});
							}
						}
						this.showLoad = false;
					});
				} else {
					this.hasData = false;
					this.showLoad = false;
				}
			} else {
				this.metricsData = false;
				this.hasData = false;
				this.showLoad = false;
			}
		});
		setTimeout(() => {
			this.calculateTickPositions();
		}, 2000);
	}

	// function to generate the highcharts with modified configuration
	drawGraph() {
		let isR103 =
			this.analyticsDataModel.config.directoryName == 'default-r103' ||
			this.analyticsDataModel.config.directoryName == 'entravision-r103';
		let format = this.chartConfig.graphConfig.xAxisConfig.labelFormat
			? this.chartConfig.graphConfig.xAxisConfig.labelFormat
			: '%e-%b';
		let stepCount = this.calculateStepCountByDate();
		let margin = this.chartConfig.graphConfig.margin ? this.chartConfig.graphConfig.margin : [10, 50, 70, 100];
		let xMin = moment.utc(this.analyticsDataModel.startDate.format('YYYYMMDD'), 'YYYYMMDD').unix() * 1000;
		let xMax = moment.utc(this.analyticsDataModel.endDate.format('YYYYMMDD'), 'YYYYMMDD').unix() * 1000;

		if (this.analyticsDataModel.startDate.format('YYYYMMDD') == this.analyticsDataModel.endDate.format('YYYYMMDD')) {
			xMax = xMin;
		} else {
			xMin = xMin - stepCount * 24 * 3600 * 1000;
			xMax = xMax + stepCount * 24 * 3600 * 1000;
		}

		this.chartObj = Highcharts.chart({
			chart: {
				renderTo: this.graphElement ? this.graphElement.nativeElement : 'chart',
				type: 'scatter',
				height: this.chartConfig.height ? this.chartConfig.height : '384px',
				margin: margin,
				plotBorderWidth: this.chartConfig.graphConfig.plotBorderWidth
					? this.chartConfig.graphConfig.plotBorderWidth
					: 0,
				backgroundColor: this.chartConfig.backgroundColor ? this.chartConfig.backgroundColor : ''
			},
			title: {
				text: null
			},
			subtitle: {
				text: null
			},
			xAxis: {
				min: xMin,
				max: xMax,
				tickPositioner: function () {
					let step = stepCount * 24 * 3600 * 1000;
					let positions = [];
					for (var i = this.min; i <= this.max; i += step) {
						positions.push(i);
					}
					return positions;
				},
				labels: {
					rotation:
						this.chartConfig.graphConfig.xAxisConfig.labels && this.chartConfig.graphConfig.xAxisConfig.labels.rotation
							? this.chartConfig.graphConfig.xAxisConfig.labels.rotation
							: 0,
					formatter: function () {
						return Highcharts.dateFormat(format, Number(this.value));
					}
				},
				showFirstLabel: false,
				showLastLabel: false,
				endOnTick: true,
				startOnTick: true,
				tickWidth:
					this.chartConfig.graphConfig.xAxisConfig.tickWidth || this.chartConfig.graphConfig.xAxisConfig.tickWidth == 0
						? this.chartConfig.graphConfig.xAxisConfig.tickWidth
						: 1,
				lineWidth:
					this.chartConfig.graphConfig.xAxisConfig.lineWidth || this.chartConfig.graphConfig.xAxisConfig.lineWidth == 0
						? this.chartConfig.graphConfig.xAxisConfig.lineWidth
						: 1
			},
			tooltip: this.getToolTipConfig(),
			yAxis: [
				{
					title: {
						text: 'Time'
					},
					gridLineDashStyle: 'Solid',
					gridLineWidth:
						this.chartConfig.graphConfig.yAxis[0].gridLineWidth ||
						this.chartConfig.graphConfig.yAxis[0].gridLineWidth == 0
							? this.chartConfig.graphConfig.yAxis[0].gridLineWidth
							: 1,
					allowDecimals: false,
					min: 0,
					max: 24 * 3600 * 1000,
					tickInterval: 4 * 3600 * 1000,
					type: 'datetime',
					labels: {
						formatter: function () {
							return isR103
								? Highcharts.dateFormat('%l %p', Number(this.value))
								: Highcharts.dateFormat('%l:%M %p', Number(this.value));
						}
					}
				}
			],
			credits: {
				enabled: false
			},
			plotOptions: {
				series: {
					marker: {
						radius: this.chartConfig.graphConfig.legendConfig.radius
							? this.chartConfig.graphConfig.legendConfig.radius
							: 4
					},
					enableMouseTracking: true,
					keys: ['x', 'y', 'tooltip'],
					events: {
						legendItemClick: (el) => {
							if (el.target['userOptions'].name == 'Answered') {
								this.graphFilterDisabled = el.target.visible;
							}

							if (
								(el.target['userOptions'].name == 'Answered' &&
									el.target.visible &&
									!el.target.chart.legend.allItems[1].visible) ||
								(el.target['userOptions'].name == 'Missed' &&
									el.target.visible &&
									!el.target.chart.legend.allItems[0].visible)
							) {
								el.target.chart.yAxis[0].update({ visible: false });
								el.target.chart.xAxis[0].update({ visible: false });
							} else {
								el.target.chart.yAxis[0].update({ visible: true });
								el.target.chart.xAxis[0].update({ visible: true });
							}
						}
					},
					states: {
						inactive: {
							opacity: 1
						}
					}
				}
			},
			legend: {
				align: this.chartConfig.graphConfig.legendConfig.align
					? HIGHCHARTS_LEGEND_ALIGN[this.chartConfig.graphConfig.legendConfig.align]
					: 'center',
				layout: 'horizontal',
				verticalAlign: HIGHCHARTS_LEGEND_VERTICAL_ALIGN[this.chartConfig.graphConfig.legendConfig.verticalAlign],
				floating: false,
				symbolPadding: 5,
				itemWidth: this.chartConfig.graphConfig.legendConfig.itemWidth
					? this.chartConfig.graphConfig.legendConfig.itemWidth
					: 180,
				symbolRadius:
					this.chartConfig.seriesConfig[0].marker && this.chartConfig.seriesConfig[0].marker.symbolRadius
						? this.chartConfig.seriesConfig[0].marker.symbolRadius
						: 12,
				x: this.chartConfig.graphConfig.legendConfig.x ? this.chartConfig.graphConfig.legendConfig.x : 0,
				y: this.chartConfig.graphConfig.legendConfig.y ? this.chartConfig.graphConfig.legendConfig.y : 0
			},
			series: this.graphObj.series
		});
	}

	//function to return primary color with provided opacity in argument
	getColorWithOpactity(opacity: number) {
		return this.getColorFromColorConfig(0, opacity);
	}

	// function to map graphdata from response
	mapCallGraphDataToInterface(responseArray: any[]) {
		const callsData: CallGraph[] = [];
		for (const response of responseArray) {
			const callGraphData: CallGraph = <CallGraph>{};
			callGraphData.dateObj = parseInt(response.date);
			callGraphData.time = response.time;
			callGraphData.callDurations = response.calls_duration;
			callGraphData.answeredCalls = parseInt(response.answered_calls_count);
			callGraphData.missedCalls = parseInt(response.missed_calls_count);
			callsData.push(callGraphData);
		}
		return callsData;
	}

	// function to build charts series object which will be passed to highchats
	protected buildChartSeriesObj(graphData: any) {
		const chartSeries: any = [];
		//series 1 : answered calls
		const answeredCalls: any = {};
		let seriesIndex = 0;
		answeredCalls.type = this.chartConfig.seriesConfig[seriesIndex].type;
		answeredCalls.name = this.chartConfig.seriesConfig[seriesIndex].seriesName;
		answeredCalls.color = this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1);
		answeredCalls.legendIndex = this.chartConfig.seriesConfig[seriesIndex].legendIndex;
		answeredCalls.zIndex = 1;
		answeredCalls.marker = {
			symbol: this.chartConfig.seriesConfig[seriesIndex].marker.symbol,
			enabled: this.chartConfig.seriesConfig[seriesIndex].marker.enabled,
			fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig),
			states: {
				hover: {
					fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1)
				},
				halo: {
					opacity: this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						? this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						: 0.3
				}
			}
		};

		//series 2 : missed calls
		const missedCalls: any = {};
		seriesIndex = 1;
		missedCalls.type = this.chartConfig.seriesConfig[seriesIndex].type;
		missedCalls.name = this.chartConfig.seriesConfig[seriesIndex].seriesName;
		missedCalls.color = this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1);
		missedCalls.legendIndex = this.chartConfig.seriesConfig[seriesIndex].legendIndex;
		missedCalls.zIndex = 2;
		missedCalls.marker = {
			symbol: this.chartConfig.seriesConfig[seriesIndex].marker.symbol,
			enabled: this.chartConfig.seriesConfig[seriesIndex].marker.enabled,
			fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig),
			states: {
				hover: {
					fillColor: this.getColorFromColorConfigObj(this.chartConfig.seriesConfig[seriesIndex].colorConfig, 1)
				},
				halo: {
					opacity: this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						? this.chartConfig.seriesConfig[seriesIndex].colorConfig.opacity
						: 0.3
				}
			}
		};

		// getting filter values
		let minCallDurationFilter: any;
		let maxCallDurationFilter: any;
		switch (Number(this.selectedValue)) {
			case 4:
				minCallDurationFilter = 60;
				maxCallDurationFilter = false;
				break;
			case 3:
				minCallDurationFilter = 30;
				maxCallDurationFilter = 60;
				break;
			case 2:
				minCallDurationFilter = 0;
				maxCallDurationFilter = 30;
				break;
			case 1:
			default:
				minCallDurationFilter = false;
				maxCallDurationFilter = false;
		}

		let seriesData = this.getSeriesData(graphData, minCallDurationFilter, maxCallDurationFilter);
		answeredCalls.data = seriesData.answeredCalls;
		missedCalls.data = seriesData.missedCalls;

		chartSeries.push(answeredCalls);
		chartSeries.push(missedCalls);
		return chartSeries;
	}

	protected getSeriesData(graphData: any, minCallDurationFilter: any, maxCallDurationFilter: any) {
		//creating graph data with tooltip for both series
		let answeredSeriesData = [];
		let missedSeriesData = [];
		for (let i = 0; i < graphData.length; i++) {
			// answered calls
			if (graphData[i].answeredCalls > 0) {
				let time = graphData[i].time.split(':');
				time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
				let callDurationsTooltip = graphData[i].callDurations.split(',').filter((value: any) => {
					return (
						(minCallDurationFilter == false || value > minCallDurationFilter) &&
						(maxCallDurationFilter == false || value <= maxCallDurationFilter)
					);
				});

				if (callDurationsTooltip.length > 0) {
					if (!this.isR104) {
						let plural = callDurationsTooltip.length > 1 ? 's' : '';
						callDurationsTooltip = callDurationsTooltip
							.map((duration: any, index: number) => {
								return (
									'Call ' +
									(plural ? index + 1 + ' ' : '') +
									'Duration: ' +
									Highcharts.dateFormat('%H:%M:%S', duration * 1000) +
									'<br/>'
								);
							}, plural)
							.join('');
						const tooltip = graphData[i].answeredCalls + ' Answered Call' + plural + ' <br/>' + callDurationsTooltip;
						answeredSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
					} else {
						let plural = callDurationsTooltip.length > 1 ? 's' : '';
						callDurationsTooltip = callDurationsTooltip
							.map((duration: any, index: number) => {
								return Highcharts.dateFormat('%H:%M:%S', duration * 1000) + '<br/>';
							}, plural)
							.join('');
						const tooltip = graphData[i].answeredCalls + 'Call' + plural + ' - ' + callDurationsTooltip;
						answeredSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
					}
				}
			}
			// missed Calls
			if (graphData[i].missedCalls > 0) {
				if (!this.isR104) {
					let time = graphData[i].time.split(':');
					time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
					let plural = graphData[i].missedCalls > 1 ? 's' : '';
					const tooltip = graphData[i].missedCalls + ' Missed Call' + plural;
					missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				} else {
					let time = graphData[i].time.split(':');
					time = (Number(time[0]) * 3600 + Number(time[1]) * 60 + Number(time[2])) * 1000;
					let plural = graphData[i].missedCalls > 1 ? 's' : '';
					const tooltip = graphData[i].missedCalls + ' Call' + plural + ' Missed';
					missedSeriesData.push([graphData[i].dateObj * 1000, time, tooltip]);
				}
			}
		}

		return { answeredCalls: answeredSeriesData, missedCalls: missedSeriesData };
	}

	//function to get tooltipconfig
	getToolTipConfig() {
		return {
			useHTML: true,
			formatter: function () {
				return (
					Highcharts.dateFormat('%m/%d/%Y', this.x) +
					'  ' +
					Highcharts.dateFormat('%l:%M:%S %p', this.y) +
					'<br/>' +
					this.point.tooltip
				);
			}
		};
	}

	//function to map call mertrics from response
	mapCallMetricsDataTointerface(response: any) {
		if (response[0]) {
			let metricsData: CallMetrics = <CallMetrics>{};
			metricsData.answeredCalls = !UtilityService.isUndefinedOrNull(response[0].answered_calls)
				? Math.round(parseInt(response[0].answered_calls))
				: 0;
			metricsData.missedCalls = !UtilityService.isUndefinedOrNull(response[0].missed_calls)
				? Math.round(parseInt(response[0].missed_calls))
				: 0;
			metricsData.avgDuration = !UtilityService.isUndefinedOrNull(response[0].avg_duration_in_minutes)
				? response[0].avg_duration_in_minutes
				: 0;
			if (!metricsData.answeredCalls && !metricsData.missedCalls && !metricsData.avgDuration) {
				this.metricsData = false;
			} else {
				this.metricsData = metricsData;
			}
		} else {
			this.metricsData = false;
		}
	}

	protected getColorFromColorConfigObj(colorConfig: ColorConfig, opacity?: number) {
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}

	protected calculateTickPositions() {
		let startDate = moment(this.analyticsDataModel.startDate).add(5, 'hours').add(30, 'minutes');
		let endDate = moment(this.analyticsDataModel.endDate).add(5, 'hours').add(30, 'minutes');
		const count = endDate.diff(startDate, 'days');
		const stepCount = Math.ceil(count / (this.defaultCount * 2));
		const positions = [];
		let firstTick = startDate.valueOf() / 1000 / (24 * 3600);
		if (stepCount == 0) {
			positions.push((firstTick - 1) * 24 * 3600 * 1000);
			positions.push(firstTick * 24 * 3600 * 1000);
			positions.push((firstTick + 1) * 24 * 3600 * 1000);
		} else {
			positions.push((firstTick - Math.ceil(stepCount / 2)) * 24 * 3600 * 1000);
			positions.push(firstTick * 24 * 3600 * 1000);
			for (let i = 0; i < count; i += stepCount) {
				firstTick += stepCount;
				positions.push(firstTick * 24 * 3600 * 1000);
			}
			positions.push(firstTick * 24 * 3600 * 1000);
			positions.push((firstTick + Math.ceil(stepCount / 2)) * 24 * 3600 * 1000);
		}
		this.tickPositions = positions;
	}

	downloadCSVData(event) {
		event.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadcsvcolumns
		);
	}

	protected calculateStepCountByDate() {
		let count = this.analyticsDataModel.endDate.diff(this.analyticsDataModel.startDate, 'days');
		if (count <= this.defaultCount) {
			return 1;
		}
		return Math.ceil(count / this.defaultCount);
	}
}
